import _ from 'lodash';
import { Form } from 'react-bootstrap';
import React, { Component } from 'react';
import FaAsyncTypeahead from '../../../../../../facturotopia/fa-typahead/FaAsyncTypeahead';

class CartaPorteNumEstacionSuggestions extends Component {
  __cache = {};

  handleOnSelect = (value) => {
    const { name } = this.props;

    // Caché
    this.__cache[name] = value;

    this.props.onChange({
      [name]: !!value ? value.value : '',
    });
  };

  isRequired = (value) => {
    return value === false && this.isFieldRequired();
  };

  isFieldRequired() {
    const rules = this.props.rules;

    const result = rules.filter((rule) => rule === 'required');

    let isRequired = false;

    if (!_.isEmpty(result)) {
      isRequired = true;
    }

    return isRequired;
  }

  render() {
    const { name, onChange, selected, onRef, label, options, ...rest } = this.props;

    const selectedOption = !!this.__cache[this.props.name] && [this.__cache[this.props.name]];

    return (
      <>
        {!!label && (
          <Form.Label className={this.isRequired(selectedOption) && 'text-danger font-weight-bold'}>
            {label} {this.isFieldRequired() && <strong> * </strong>}
          </Form.Label>
        )}

        <FaAsyncTypeahead
          placeholder=""
          help=""
          onSelect={this.handleOnSelect}
          options={options}
          selected={selectedOption || []}
          onSetRef={onRef}
          {...rest}
        />
      </>
    );
  }
}

export default CartaPorteNumEstacionSuggestions;
